import React from 'react';
import CONFIG from "../../config";

const { LINKS } = CONFIG;

interface IAdditionally {
    className?: string;
    isFooter?: boolean
}

const Additionally: React.FC<IAdditionally> = ({ className, isFooter }) => (
    <ul className={className}>
        <li><a href={LINKS.BAIBOL.NEWS} target="_blank" rel="noopener noreferrer nofollow">Новости</a></li>
        <li><a href={LINKS.BAIBOL.LITERACY} target="_blank" rel="noopener noreferrer nofollow">Важно знать</a></li>
        <li><a href={LINKS.BAIBOL.FAQ} target="_blank" rel="noopener noreferrer nofollow">Вопрос-ответ</a></li>
        {isFooter && <li><a href={LINKS.BAIBOL.SEARCH_MAP} target="_blank" rel="noopener noreferrer nofollow">Карта сайта</a></li>}
    </ul>
);

export default Additionally;


// Additionally